import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { buildWhatsAppUrl } from "../data/watches";

const NAV_LINKS = [
  { href: "#coleccion", label: "Colección", key: "coleccion" },
  { href: "#artesania", label: "Artesanía", key: "artesania" },
  { href: "#historia", label: "Historia", key: "historia" },
  { href: "#faqs", label: "FAQs", key: "faqs" },
  { href: "#contacto", label: "Contacto", key: "contacto" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050B14]/80 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 flex items-center justify-between h-20">
        <Logo size="md" />

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.key}`}
              className="nav-link-rw font-accent-rw text-[11px] uppercase tracking-[0.28em] text-slate-300 hover:text-[var(--brand-gold)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href="#coleccion"
            data-testid="header-catalog-button"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-[var(--brand-gold)]/60 text-[var(--brand-gold)] hover:bg-[var(--brand-gold)] hover:text-[var(--brand-bg)] transition-all duration-300 text-[11px] uppercase tracking-[0.24em] font-medium"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--brand-whatsapp)] animate-pulse" />
            <span translate="no">Catálogo</span>
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-slate-100"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menú"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-[max-height,opacity] duration-500 bg-[#050B14]/95 backdrop-blur-xl border-b border-white/5 ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-6 py-8 flex flex-col gap-6">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-accent-rw text-xs uppercase tracking-[0.3em] text-slate-300 hover:text-[var(--brand-gold)] transition"
              data-testid={`mobile-nav-link-${l.key}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-header-whatsapp-button"
            className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 border border-[var(--brand-gold)]/60 text-[var(--brand-gold)] text-[11px] uppercase tracking-[0.24em]"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--brand-whatsapp)]" />
            Escribir por WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
